<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1200"
  >
    <div
      class="rounded-lg shadow-lg p-4 subscription-popup poppins"
      style="background-color: #f8f9fb"
    >
      <!-- Close Button -->
      <div class="text-right mt-3">
        <v-btn icon @click="toggleModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <!-- Header -->
      <div class="text-center mb-4">
        <b-button-group class="toggle-group mt-3 btn-group custom-rounded">
          <b-button
            class="btn-billing-cycle font-weight-bolder"
            :variant="
              billingCycle === 'monthly'
                ? 'billing-cycle-active'
                : 'billing-cycle-inactive'
            "
            @click="billingCycle = 'monthly'"
          >
            Monthly
          </b-button>
          <b-button
            class="btn-billing-cycle font-weight-bolder"
            :variant="
              billingCycle === 'annual'
                ? 'billing-cycle-active'
                : 'billing-cycle-inactive'
            "
            @click="billingCycle = 'annual'"
          >
            Annual
            <!--            <span class="ml-1">(Save 15%)</span>-->
          </b-button>
        </b-button-group>
      </div>

      <!-- Plans -->
      <v-row class="justify-center mb-6 mt-8">
        <!-- Free Plan -->
        <v-col cols="12" md="5">
          <div
            class="bg-white border d-flex flex-column h-100 justify-content-between px-7 py-9 rounded-lg shadow-sm text-left"
          >
            <div>
              <div
                class="d-flex align-items-center justify-content-center mb-3 mt-2"
              >
                <img src="/img/plus/IQ-Core.png" alt="IQ Core" width="177" />
              </div>
              <h6 class="font-size-h1 font-weight-bolder py-1 text-center">
                <!-- ${{
                  billingCycle === "monthly"
                    ? `${coreFeatures.monthly_price} /Mo`
                    : `${coreFeatures.yearly_price} /Year`
                }} -->
                Free
              </h6>
              <div class="d-flex justify-content-center">
                <p
                  class="badge badge-secondary p-4 font-size-base iq-core-subscription-badge rounded-lg"
                >
                  Your Current Subscription
                </p>
              </div>

              <ul class="mt-5 pl-3 list-unstyled">
                <li
                  class="py-2 font-weight-medium"
                  v-for="(feature, index) in coreFeatures.features"
                  :key="index"
                >
                  <img
                    src="/img/plus/checkmark.png"
                    alt="checkmark"
                    width="20"
                    class="mr-2"
                  />
                  {{ feature }}
                </li>
              </ul>
            </div>

            <!-- <div class="d-flex justify-content-center">
              <button class="core-subscribe-button py-2 px-7 rounded-lg mt-7">
                Start Your 14-Day Trail
              </button>
            </div> -->
          </div>
        </v-col>

        <!-- Plus Plan -->
        <v-col cols="12" md="5">
          <div
            class="bg-white d-flex flex-column h-100 justify-content-between px-7 py-9 rounded-lg shadow-sm text-left"
            style="background-color: #f9f4ff; border: 3px solid #c08af8"
          >
            <div>
              <div
                class="d-flex align-items-center justify-content-center mb-3"
              >
                <img src="/img/plus/IQ-Plus.png" alt="IQ Plus" width="180" />
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <h6
                  class="d-inline font-size-h1 font-weight-bolder py-1 text-center"
                  :class="{
                    'text-decoration-line-through text-dark-50 font-size-h2 me-5':
                      hasDiscount,
                  }"
                >
                  <img
                    src="/img/dirham.svg"
                    style="height: 18px; padding-right: 5px; margin-bottom: 3px"
                  />
                  {{ normalPrice + monthlyYearlyText }}
                  <!--                    billingCycle === "monthly"-->
                  <!--                      ? `${plusFeatures.monthly_price} /Mo`-->
                  <!--                      : `${plusFeatures.yearly_price} /Year`-->
                </h6>
                <h6
                  v-if="hasDiscount"
                  class="d-inline font-size-h1 font-weight-bolder py-1 text-center"
                >
                  <!--                  <img-->
                  <!--                    v-if="displayDiscountPrice !== 'Free'"-->
                  <!--                    src="/img/dirham.svg"-->
                  <!--                    style="height: 18px; padding-right: 5px; margin-bottom: 3px"-->
                  <!--                  />-->

                  {{
                    displayDiscountPrice === "Free"
                      ? displayDiscountPrice
                      : displayDiscountPrice + monthlyYearlyText
                  }}
                </h6>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  @click="subscribe"
                  class="badge badge-secondary py-3 px-13 font-size-base plus-subscribe-button-relative rounded-lg"
                >
                  Upgrade to Plus
                </button>
              </div>

              <ul class="mt-8 pl-3 list-unstyled">
                <li
                  class="py-2 font-weight-medium"
                  v-for="(feature, index) in plusFeatures.features"
                  :key="index"
                >
                  <img
                    src="/img/plus/checkmark.png"
                    alt="checkmark"
                    width="20"
                    class="mr-2"
                  />
                  {{ feature }}
                </li>
              </ul>

              <div class="d-flex justify-content-center mt-10">
                <button
                  @click="subscribe"
                  class="badge badge-secondary py-3 px-13 font-size-base plus-subscribe-button-relative rounded-lg"
                >
                  Upgrade to Plus
                </button>
              </div>
            </div>
          </div>
          <p class="ai-badge">Unlock A.I Productivity</p>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
// import Swal from "sweetalert2";

import { SET_APP_DATA } from "@/core/services/store/auth.module.js";
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "SubscriptionModal",
  props: ["refresher", "pageLoader"],

  data: () => ({
    dialog: false,
    billingCycle: "monthly",
    coreFeatures: {},
    plusFeatures: {},
    userData: null,
  }),
  methods: {
    async toggleModal() {
      if (!this.dialog) {
        await this.loadDataFromServer();
      } else if (this.dialog && this.userData) {
        // console.log(this.userData);
        this.$store.commit(SET_APP_DATA, this.userData);
      }
      this.dialog = !this.dialog;
    },
    // successModal() {
    //   this.toggleModal();
    // },
    loadDataFromServer() {
      this.$store.commit(SET_PAGE_LOADING, true);

      return ApiService.post("/memberships")
        .then(({ data }) => {
          this.coreFeatures = data.memberships[0];
          this.plusFeatures = data.memberships[1];

          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch(() => {
          this.dialog = false;
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    subscribe() {
      this.$store.commit(SET_PAGE_LOADING, true);

      const data = {
        subscription_id: this.getCustomerId,
      };

      ApiService.post("/memberships/subscribe", data)
        .then(() => {
          this.toggleModal();
        })
        // .then(() => {
        //   this.$emit("showSuccessModal");
        // })
        .then(async () => {
          const { data } = await ApiService.post("/verify");
          this.$store.commit(SET_APP_DATA, data);
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  computed: {
    // billingCycle === "monthly"-->
    // <!--                      ? plusFeatures.discounted_monthly_price !== 0-->
    // <!--                        ? `$${plusFeatures.discounted_monthly_price}`-->
    // <!--                        : "Free"-->
    // <!--                      : plusFeatures.discounted_yearly_price !== 0-->
    // <!--                      ? `$${plusFeatures.discounted_yearly_price}`-->
    // <!--                      : "Free"-->

    displayDiscountPrice() {
      return this.discountPrice === 0 ? "Free" : this.discountPrice;
    },
    discountPrice() {
      return this.billingCycle === "monthly"
        ? this.plusFeatures.discounted_monthly_price
        : this.plusFeatures.discounted_yearly_price;
    },
    normalPrice() {
      return this.billingCycle === "monthly"
        ? this.plusFeatures.monthly_price
        : this.plusFeatures.yearly_price;
    },
    monthlyYearlyText() {
      return this.billingCycle === "monthly" ? ` /Mo` : ` /Year`;
    },
    hasDiscount() {
      if (this.billingCycle && this.plusFeatures) {
        return this.billingCycle === "monthly"
          ? this.plusFeatures.discounted_monthly_price !==
              this.plusFeatures.monthly_price
          : this.plusFeatures.discounted_yearly_price !==
              this.plusFeatures.yearly_price;
      } else return false;
    },
    getCustomerId() {
      return this.$store.getters.getCustomerId;
    },
  },
};
</script>

<style scoped>
.subscription-popup {
  font-family: "Poppins", sans-serif;
}
/* .toggle-group .btn {
  border-radius: 50px;
  background: #eff3f7 !important;
  padding: 5px 8px 5px 8px;
} */
.iq-core-subscription-badge {
  background-color: #939393 !important;
  color: #f3f3f3 !important;
}
.iq-plus-subscription-badge {
  background: linear-gradient(#3b40ff, #3b40ff) 50% 50% / calc(100% - 24px)
      calc(100% - 24px) no-repeat,
    linear-gradient(90deg, #3b40ff 0%, #7006ae 100%);
  color: white !important;
}
.btn-billing-cycle-active {
  background: white !important;
  border-radius: 10px;
}
.billing-cycle-inactive {
  background: white !important;
  border-radius: 10px;
}
.toggle-group {
  background: #f0f4f8 !important;
  padding: 5px 4px 5px 4px;
}
.custom-rounded .btn:first-child {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.custom-rounded .btn:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.btn-billing-cycle {
  border-radius: 7px !important;
  width: 180px;
}
.ai-badge {
  position: absolute;
  top: 1px;
  left: 34%;
  z-index: 10;
  background: black;
  color: white;
  padding: 5px 24px;
  border-radius: 7px;
}
.core-subscribe-button {
  background-color: #939393 !important;
  color: white;
}
.plus-subscribe-button-relative {
  background: linear-gradient(90deg, #8e2de2 0%, #4a00e0 100%);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 9999px; /* fully rounded pill shape */
  cursor: pointer;
  transition: background 0.3s ease;
}

.plus-subscribe-button:hover {
  opacity: 0.9;
}

.strikethrough-img {
  height: 18px;
  padding-right: 5px;
  /* Creates a solid line across the middle of the image */
  background: linear-gradient(
    transparent 47%,
    #7e8299 47%,
    #7e8299 53%,
    transparent 53%
  );
}
</style>
